export default class Outpayment {
  /**
   * Create new invoice and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * @return {Date}
   */
  get createDateTimeUtc () {
    return this._createDateTimeUtc
  }

  /**
   * @param {string} value
   */
  set createDateTimeUtc (value) {
    this._createDateTimeUtc = new Date(value)
  }

  /**
   * @return {Date}
   */
  get scheduledDateTimeUtc () {
    return this._scheduledDateTimeUtc
  }

  /**
   * @param {string} value
   */
  set scheduledDateTimeUtc (value) {
    this._scheduledDateTimeUtc = new Date(value)
  }

  /**
   * @return {Date}
   */
  get outPaidDateTimeUtc () {
    return this._outPaidDateTimeUtc
  }

  /**
   * @param {string} value
   */
  set outPaidDateTimeUtc (value) {
    this._outPaidDateTimeUtc = new Date(value)
  }

  /**
   * @return {string}
   */
  get beneficiary () {
    return this._beneficiary.customerId + ' ' + this._beneficiary.nameOnBankAccount + ' (' + this._beneficiary.iban + ' -  ' + this._beneficiary.bic + ')'
  }

  /**
   * @param {string} value
   */
  set beneficiary (value) {
    this._beneficiary = value
  }
}
